import React from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import HeroSection from "../../components/sections/Hero/HeroSection";
import heroLottieAnimation from "../../assets/animations/Sygnet-Appotype.json";
import clutch1 from "../../assets/images/clutch1.png";
import clutch2 from "../../assets/images/clutch2.png";
import soda from "../../assets/images/soda-logo.png";
import logo from "../../assets/images/logo-short-dark.svg";
import { MdKeyboardArrowRight } from "react-icons/md";
import ServicesSection from "../../components/sections/Services/ServicesSection";
import CalculatorSection from "../../components/sections/Calculator/CalculatorSection";
import StatsSection from "../../components/sections/Stats/StatsSection";
import CarouselSection from "../../components/sections/Carousel/CarouselSection";
import CaseStudySection from "../../components/sections/CaseStudy/CaseStudySection";
import ContactSection from "../../components/sections/Contact/ContactSection";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import SEOMetaTags from "../../components/SEO/SEOMetaTags";

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const heroButtons = [
    {
      label: t("home.hero.button.meeting"),
      variant: "secondary",
      onClick: () => navigate("/contact", { state: { scrollToCalendar: true } }),
      rightIcon: <MdKeyboardArrowRight size={32} />,
    },
    {
      label: t("home.hero.button.services"),
      variant: "outlineNoTheme",
      onClick: () => {
        const servicesSection = document.querySelector('.servicesSection');
        if (servicesSection) {
          const elementPosition = servicesSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 64;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      },
      rightIcon: <MdKeyboardArrowRight size={32} />,
    },
  ];

  const clutchImages = [
    { 
      image: <img src={clutch1} alt="Clutch Logo 1" />,
      link: "https://clutch.co/profile/appotype#logo"
    },
    { 
      image: <img src={clutch2} alt="Clutch Logo 2" />,
      link: "https://clutch.co/profile/appotype#logo"
    },
  ];

  const groupImages = [
    { 
      image: <img src={soda} alt="Soda" />,
      link: "https://sodapl.com/en/"
    },
  ];

  return (
    <>
      <SEOMetaTags
        title={{
          pl: "Appotype | Software Agency",
          en: "Appotype | Software Agency"
        }}
        description={{
          pl: "Appotype - Software Agency. Tworzymy oprogramowanie (AI, Medtech, Web, Mobile), które automatyzuje procesy i zwiększa konkurencyjność Twojej firmy. Audyty IT i rozwiązania Enterprise.",
          en: "Appotype - Software Agency. We build software (AI, Medtech, Web, Mobile) that automates processes and increases your company's competitiveness. IT Audits & Enterprise Solutions."
        }}
        canonicalUrl="/"
      />
      <BaseLayout headerCustomBg={true} isHomePage={true}>
        <HeroSection
          title={t("home.hero.title")}
          subtitle={t("home.hero.subtitle")}
          heroButtons={heroButtons}
          clutchImages={clutchImages}
          groupImages={groupImages}
          heroLottieAnimation={heroLottieAnimation}
          heroStaticSvg={logo}
        />
        <ServicesSection />
        <CalculatorSection />
        <StatsSection />
        <CarouselSection />
        <CaseStudySection title={t("caseStudy.title")} />
        <ContactSection />
      </BaseLayout>
    </>
  );
};

export default HomePage;
